import { createTheme } from '@mui/material/styles';

// Define color palette
export const colors = {
  // Primary colors
  primary: {
    main: '#8E24AA',
    light: '#AB47BC',
    dark: '#6A1B9A',
    contrastText: '#FFFFFF',
  },
  // Secondary colors
  secondary: {
    main: '#FFC107',
    light: '#FFD54F',
    dark: '#FFA000',
    contrastText: '#000000',
  },
  // Background colors
  background: {
    default: '#121212',
    paper: '#1E1E1E',
    card: '#1E1E1E',
  },
  // Text colors
  text: {
    primary: '#FFFFFF',
    secondary: '#AAAAAA',
    disabled: '#757575',
  },
  // Border colors
  border: {
    main: '#8E24AA',
    light: '#AB47BC',
  },
  // Divider color
  divider: '#333333',
  // Other colors
  error: {
    main: '#F44336',
  },
  warning: {
    main: '#FF9800',
  },
  info: {
    main: '#2196F3',
  },
  success: {
    main: '#8E24AA',
  },
};

// Define spacing
export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
};

// Define breakpoints
export const breakpoints = {
  values: {
    xs: 0,
    sm: 375,
    md: 600,
    lg: 960,
    xl: 1280,
  },
};

// Define shadows
export const shadows = {
  card: '0 4px 12px rgba(0, 0, 0, 0.2)',
};

// Create and export the theme
const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: colors.primary,
    secondary: colors.secondary,
    background: {
      default: colors.background.default,
      paper: colors.background.paper,
    },
    text: {
      primary: colors.text.primary,
      secondary: colors.text.secondary,
    },
    error: {
      main: colors.error.main,
    },
    warning: {
      main: colors.warning.main,
    },
    info: {
      main: colors.info.main,
    },
    success: {
      main: colors.success.main,
    },
    divider: colors.divider,
  },
  spacing: (factor: number) => `${factor * 8}px`,
  breakpoints: {
    values: breakpoints.values,
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '22px',
      fontWeight: 500,
    },
    h2: {
      fontSize: '28px',
      fontWeight: 500,
    },
    body1: {
      fontSize: '16px',
    },
    body2: {
      fontSize: '14px',
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          padding: '10px 16px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: colors.background.card,
          borderRadius: '16px',
          boxShadow: shadows.card,
          border: `1px solid ${colors.border.main}`,
        },
      },
    },
  },
});

export default theme;
